import { defineStore } from "pinia";
import http from "@/http";
import {
  LIST_ATIVIDADE,
  ADD_ATIVIDADE,
  UPDATE_ATIVIDADE,
  DEL_ATIVIDADE,
  LIST_TRABALHO,
  ADD_TRABALHO,
  UPDATE_TRABALHO,
  DEL_TRABALHO,
} from "@/http/url";

export const useAtividadeStore = defineStore("AtividadeStore", {
  state: () => {
    return {
      atividades: [],
      trabalhos: [],
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_ATIVIDADES() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_ATIVIDADE)
          .then((response) => {
            this.atividades = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_ATIVIDADE(atividade) {
      return http
        .post(ADD_ATIVIDADE, atividade)
        .then((response) => this.atividades.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_ATIVIDADE(atividade) {
      return http.put(`${UPDATE_ATIVIDADE + atividade.id}`, atividade);
    },

    REMOVER_ATIVIDADE(id) {
      return http.delete(`${DEL_ATIVIDADE + id}`).then(() => (this.atividades = this.atividades.filter((atv) => atv.id != id)));
    },

    LISTAR_TRABALHOS(atividadeID) {
      return new Promise((resolve, reject) => {
        http
          .get(`${LIST_TRABALHO + atividadeID}`)
          .then((response) => {
            this.trabalhos = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_TRABALHO(trabalho) {
      return http.post(ADD_TRABALHO, trabalho).catch((erro) => {
        console.log(erro);
      });
    },

    ALTERAR_TRABALHO(trabalho) {
      return http.put(`${UPDATE_TRABALHO + trabalho.id}`, trabalho);
    },

    REMOVER_TRABALHO(id) {
      return new Promise((resolve, reject) => {
        http
          .delete(`${DEL_TRABALHO + id}`)
          .then(() => {
            this.trabalhos = this.trabalhos.filter((trab) => trab.id != id);
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    TRABALHO_ALTERADO(index) {
      this.trabalhos[index]._rowVariant = "danger";
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getAtividades() {
      return this.atividades;
    },

    getById: (state) => {
      return (id) => {
        return state.atividades.filter((ativ) => !id || ativ.id == id);
      };
    },

    getAtividadeLoad(state) {
      return state.loaded;
    },

    getTrabalhos(state) {
      return state.trabalhos;
    },

    getFilterAtividades: (state) => {
      return (filtro) => {
        let filtrada = state.atividades;

        filtrada = filtrada.filter(
          (a) =>
            !filtro ||
            (a.descricao.includes(filtro.descricao) &&
              a.cliente.nome.includes(filtro.cliente) &&
              a.grupo.includes(filtro.grupo) &&
              a.responsavel.includes(filtro.responsavel))
        );

        return filtrada;
      };
    },
  },
});
